import base from "/app/images/genius-inactive.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");